/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { EOverrideVisualStatus } from './override-visual-status.enum';

/**
 * Maps each override visual status to its display color.
 * Blue for active, grey for planned, orange for expired.
 */
export const OVERRIDE_VISUAL_CONFIG: Record<EOverrideVisualStatus, { color: string }> = {
  [EOverrideVisualStatus.ACTIVE]: { color: '#0000FF' },
  [EOverrideVisualStatus.PLANNED]: { color: '#808080' },
  [EOverrideVisualStatus.EXPIRED]: { color: '#FFA500' }
};

/**
 * All visual styling constants for override polyline rendering,
 * grouped by layer (dash, outline, shadow).
 */
export const OVERRIDE_POLYLINE_STYLE = {
  dash: {
    weight: 6,
    repeat: '25px',
    zIndex: 5
  },
  outline: {
    color: '#FFFFFF',
    weight: 12,
    zIndex: 4
  },
  shadow: {
    color: '#000000',
    opacity: 0.25,
    weight: 18,
    zIndex: 3
  }
} as const;

/**
 * Base Google Maps polyline options for override dotted-line rendering.
 * The solid stroke is hidden (opacity 0) and replaced by a repeating
 * SVG dash icon to produce the dotted appearance.
 */
export const OVERRIDE_POLYLINE_BASE_OPTIONS: Partial<google.maps.PolylineOptions> = {
  strokeOpacity: 0,
  strokeWeight: OVERRIDE_POLYLINE_STYLE.dash.weight,
  geodesic: true,
  clickable: false,
  zIndex: OVERRIDE_POLYLINE_STYLE.dash.zIndex,
  icons: [
    {
      icon: {
        path: 'M 0,-1 0,1',
        strokeOpacity: 1,
        scale: OVERRIDE_POLYLINE_STYLE.dash.weight
      },
      offset: '0',
      repeat: OVERRIDE_POLYLINE_STYLE.dash.repeat
    }
  ]
};
